import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useBonusRevenueTypes = () => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'bonusRevenueTypes',
    gqlEntityKey: 'bonus_revenue_types',
    queryName: 'GET_BONUS_REVENUE_TYPES_QUERY',
    createMutation: 'CREATE_BONUS_REVENUE_TYPE_MUTATION',
    updateMutation: 'UPDATE_BONUS_REVENUE_TYPE_MUTATION',
    deleteMutation: 'DELETE_BONUS_REVENUE_TYPE_MUTATION',
    transformData: (row) => {
      const channels = Array.isArray(row.applicable_channels) ? row.applicable_channels : [];
      const channelLabelMap = {
        SATIS_CIROSU: 'Satış',
        PROJE_YAZIM_CIROSU: 'Yazım',
        ONAY_SONRASI_CIROSU: 'Onay Sonrası',
      };
      return {
        ...row,
        company_name: row.company?.name || `Company ${row.company_id}`,
        name: row.name,
        code: row.code,
        coefficient: row.coefficient,
        applicable_channels: channels,
        applicable_channels_text: channels.map((c) => channelLabelMap[c] || c).join(', ') || '—',
        companyId: row.company_id,
      };
    },
    transformFormData: (formData) => ({
      name: formData.name,
      code: (formData.code || '').toUpperCase().trim(),
      coefficient: parseFloat(formData.coefficient) || 1,
      applicable_channels: Array.isArray(formData.applicable_channels)
        ? formData.applicable_channels
        : (formData.applicable_channels ? [formData.applicable_channels] : []),
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useBonusRevenueTypes };
